<template>
  <div class="container">
    <div v-if="mirrorStore.currentCategory === 2"
         class="category-list-wrapper">
      <img src="../../../assets/mirror_imgs/category_leftArrow.png"
           class="arrow left-arrow"
           @click="scrollLeft" />
      <div class="category-list">
        <div v-for="(category, index) in categoryMenu"
             :key="index"
             class="category-item"
             :class="{ active: categoryMenusSelectedKeys === category.id }"
             @click="selectCategory(category.id)">
          {{ category.name }}
        </div>
      </div>
      <img src="../../../assets/mirror_imgs/category_rightArrow.png"
           class="arrow right-arrow"
           @click="scrollRight" />
    </div>

    <div class="product-list">
      <div v-if="mirrorStore.currentCategory === 2 || mirrorStore.currentCategory === 1"
           class="product-box">
        <div v-for="productsItem in productsArray"
             :key="productsItem.id"
             :class="{ 'product-item': mirrorStore.currentCategory !== 1, 'model-item': mirrorStore.currentCategory === 1 }"
             @click="selectedProduct(productsItem as any)">
          <img :src="(productsItem as any).image ?? (productsItem as any).model_image" />
        </div>
      </div>
      <div ref="hiddenContainer"
           class="hidden"></div>
      <div v-if="mirrorStore.currentCategory === 3"
           class="product-box">
        <div v-for="productsItem in productsArray"
             class="product-item"
             @click="selectedProduct(productsItem as any)">
          <div v-if="hiddenContainer"
               class="viewer">
            <ImageCustomizeViewer v-if="productsItem?.customizedImages[0] && productsItem?.customizedImages[0].customableImage && productsItem?.customizedImages[0].customableImage.custom_areas"
                                  :id="productsItem?.customizedImages[0].customableImage.id + ''"
                                  mode="view"
                                  :container="hiddenContainer"
                                  :template-basic-parameters="templateBasicParameters(renderImageBaseUrl(productsItem), color(productsItem as any)?.value, productsItem?.customizedImages[0]?.customableImage.width, productsItem?.customizedImages[0]?.customableImage.height)"
                                  :custom-area="assignCustomizedData((productsItem as any)?.customizedImages[0]?.customableImage.custom_areas, productsItem?.customizedImages[0]?.customableImage.width, (productsItem as any)?.customizedImages[0]?.customized_areas.customable_image_scale, (productsItem as any).customizedImages[0].customized_areas.boundingRect)"
                                  :customized-image="renderImageCustomUrl(productsItem as any)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useMirrorStore } from '../../../index'
import { ImageCustomizeEditor as ImageCustomizeViewer } from '@iota-cn/ui-components'
import { categoriesTypeMenu, categoriesDetail, queryMyDesign, queryModels } from '../../../api/mirrorSpace'
import { computed, onMounted, reactive, ref, watch } from 'vue'
import { toUrl } from '@/utils'
import { findCustomableImage } from '../../../utils'

const mirrorStore = useMirrorStore()
const categoryMenu = reactive<any["categories"]>([])
const categoryMenusSelectedKeys = ref<number | string>()
const productsArray = ref<Array<any>>([])
const hiddenContainer = ref()

onMounted(() => {
  handleCategoryChange(mirrorStore.currentCategory)
})

watch(() => mirrorStore.currentCategory, async (newCategory) => {
  handleCategoryChange(newCategory)
})

const getCategoryMenus = () => {
  categoriesTypeMenu().then((result) => {
    const { categories } = result
    categoryMenu.length = 0
    categoryMenu.push(...categories)
    if (categoryMenu.length > 0) {
      categoryMenusSelectedKeys.value = categoryMenu[0].id
      getCategoryDetail(categoryMenusSelectedKeys.value as string)
    }
  })
}

const getCategoryDetail = (categoryId: string | number) => {
  categoriesDetail(categoryId as string).then(result => {
    productsArray.value = result.spus as any
  })
}

const getDesignDetail = () => {
  queryMyDesign().then(result => {
    productsArray.value = result.customSpus
  })
}

const handleCategoryChange = async (newCategory: number) => {
  if (newCategory === 1) {
    productsArray.value = []
    categoryMenu.length = 0
    const modelsList = await queryModels({ limit: 10, offset: 0, name: '' })
    productsArray.value = modelsList.list

  } else if (newCategory === 3) {
    productsArray.value = []
    categoryMenu.length = 0
    getDesignDetail()
  } else if (newCategory === 2) {
    productsArray.value = []
    getCategoryMenus()
    getCategoryDetail(categoryMenusSelectedKeys.value as string)
  }
}

const selectCategory = (category: string | number) => {
  categoryMenusSelectedKeys.value = category
  getCategoryDetail(categoryMenusSelectedKeys.value)
}

const scrollLeft = () => {
  const categoryList = document.querySelector('.category-list') as HTMLElement
  categoryList.scrollBy({ left: -100, behavior: 'smooth' })
}

const scrollRight = () => {
  const categoryList = document.querySelector('.category-list') as HTMLElement
  categoryList.scrollBy({ left: 100, behavior: 'smooth' })
}

const selectedProduct = async (product: any) => {
  mirrorStore.productItem = product
  if (mirrorStore.currentCategory === 1) {
    mirrorStore.previewModel = (product as any).model_image
    mirrorStore.isCustomModel = false
  }
  if (mirrorStore.currentCategory === 2) {
    mirrorStore.isCustomImage = false
    mirrorStore.previewClothing = (product as any).image
  } else if (mirrorStore.currentCategory === 3) {
    mirrorStore.isCustomImage = true
    mirrorStore.previewClothing = product
  }
}

const templateBasicParameters = (image: string, color: string, width: number, height: number, cornerSize: number = 15) => {
  return Object.assign({}, { image, color, width, height, cornerSize })
}

const assignCustomizedData = computed(() => (custom_areas: any, bgWidth: number, customable_image_scale: number, boundingRect: any) => {
  return Object.assign({},
    { ...(custom_areas || {}) },
    { scale: (200 / bgWidth) * (customable_image_scale || custom_areas.scale) },
    boundingRect || {})
})

const renderImageBaseUrl = (record: any) => {
  const baseCustomUrl = toUrl(findCustomableImage(color(record), record.customizedImages[0].customableImage))
  const baseHeightRatio = Math.round(record.customizedImages[0].customableImage.custom_areas.bgHeight * (200 / record.customizedImages[0].customableImage.width))
  return baseCustomUrl + `?x-oss-process=image/resize,h_${baseHeightRatio},m_lfit`
}

// 默认颜色
const color = (customSpu: any) => {
  const customSku = customSpu.customSkus[0] || null
  const color =
    customSku?.sku.attrs.filter((el: any) => {
      return el.attribute.key === "color"
    }) || null
  const value = color ? color[0].object_value : null
  return value
}

const renderImageCustomUrl = (record: any) => {
  const scaleRatio = record.customizedImages[0].customized_areas.customable_image_scale || record.customizedImages[0].customableImage.custom_areas.scale
  // const heightRatio = Math.round((record.customizedImages[0].customized_areas.boundingRect?.height || record.customizedImages[0].customableImage.custom_areas.height) * ((200 / record.customizedImages[0].customableImage.width) * scaleRatio))
  const widthRatio = Math.round((record.customizedImages[0].customized_areas.boundingRect?.width || record.customizedImages[0].customableImage.custom_areas.width) * ((200 / record.customizedImages[0].customableImage.width) * scaleRatio))
  const renderCustomUrl = toUrl(record.customizedImages[0].customized_image) + `?x-oss-process=image/resize,w_${widthRatio}/quality,q_90`
  return renderCustomUrl
}

</script>

<style scoped lang="less">
.container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;

  .category-list-wrapper {
    display: flex;
    align-items: center;
    overflow: hidden;
    /* 隐藏滚动条 */
    margin-bottom: 12px;
  }

  .arrow {
    cursor: pointer;
    width: 16px;
    height: 16px;
    object-fit: contain;
  }

  .left-arrow {
    margin-right: 10px;
  }

  .right-arrow {
    margin-left: 10px;
  }

  .category-list {
    display: flex;
    width: 100%;
    align-items: center; // 确保项目垂直居中
    overflow-x: auto;
    white-space: nowrap;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
  }

  .category-list::-webkit-scrollbar {
    display: none;
    /* Safari and Chrome */
  }

  .category-item {
    display: inline-block;
    padding: 10px;
    cursor: pointer;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 16px;
    color: #FEFEFE;
    line-height: 20px;
    opacity: 0.6;

    &.active {
      color: #3FFFE4;
    }
  }

  .product-list {
    height: 100%;
    background: url("../../../assets/mirror_imgs/category_border.png");
    background-size: 100% 100%;
    overflow: auto;
    padding: 20px;

    .product-box {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      .product-item {
        background: #D5E5E6;
        overflow: hidden;
        width: 76px;
        height: 76px;
        margin: 10px;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .model-item {
        width: 80px;
        height: 100px;
        margin: 10px;
        cursor: pointer;

        img {
          width: 80px;
          height: 100px;
          background-size: cover;
        }
      }
    }
  }

  .hidden {
    width: 75px;
    height: 75px;
    position: absolute;
    visibility: hidden;
    display: block;
    object-fit: cover;
    background-size: 100% 100%;
  }

  .viewer {
    width: 100%;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;

    @-moz-document url-prefix() {
      :deep(.fabric-div) {
        width: 48px !important;
        height: 48px !important;
      }

      :deep(.canvas-container) {
        width: 48px !important;
        height: 48px !important;
      }

      :deep(.lower-canvas) {
        width: 48px !important;
        height: 48px !important;
      }

      :deep(.upper-canvas) {
        width: 48px !important;
        height: 48px !important;
      }
    }
  }
}
</style>
